import React from "react";
import "./apiProductFeatures.css";
import {
  Sidebar,
  SidebarHeader,
  SidebarViewAll,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../layouts/layout1";
import Container from "../container/container";
import Title from "../title/title";
import Tag from "../tag/tag";
import Button from "../button/button";
import SimpleButtonWrapper from "../simpleButtonWrapper/simpleButtonWrapper";
import AskForPlans from "../askForPlans";
import ProductMarkdown from "../productMarkdown/productMarkdown";
import Divider from "../divider/divider";
import LoginLink from "../loginLink/loginLink";

const ApiProductFeatures = (props) => {
  const {
    features,
    uuid,
    disable_documentation,
    productCategories,
    isLoggedIn,
    subscribeToggler,
  } = props;

  // Extract isPSD2 check
  const isPSD2 =
    productCategories &&
    productCategories.map((p) => p.name.toUpperCase()).includes("PSD2");

  return (
    <section>
      <Container backgroundGrid>
        <Container inner>
          <SideBar>
            <SidebarLeft>
              <SidebarHeader>
                <Title type="small">
                  <Tag className="display-effect">FEATURES</Tag>
                </Title>
                <SidebarViewAll />
              </SidebarHeader>
            </SidebarLeft>
            <SidebarRight>
              <div className="features">
                {features.map((feature) => (
                  <div className="aFeature" key={feature.uuid}>
                    <div className="featureIcon">
                      {feature.icon && <img src={feature.icon.url} />}
                      {/*<img src={images[index]} />*/}
                    </div>
                    <div className="featureContent">
                      <div className="fetureTitle">
                        <span>{feature.title.toUpperCase()}</span>
                      </div>
                      <div className="fetureDescr">
                        <ProductMarkdown text={feature.description} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Action buttons aligned with feature columns */}
              <div className="feature-buttons-container">
                <div className="feature-button-left">
                  {!isPSD2 && (
                    <AskForPlans
                      disable_documentation={disable_documentation}
                      uuid={uuid}
                    />
                  )}
                </div>
                <div className="feature-button-right">
                  {isLoggedIn ? (
                    <SimpleButtonWrapper position="left">
                      <Button onClick={subscribeToggler} electro>
                        SUBSCRIBE
                      </Button>
                    </SimpleButtonWrapper>
                  ) : (
                    <SimpleButtonWrapper position="left">
                      <LoginLink>
                        <Button electro>SUBSCRIBE</Button>
                      </LoginLink>
                    </SimpleButtonWrapper>
                  )}
                </div>
              </div>
            </SidebarRight>
          </SideBar>
        </Container>
        <Divider />
      </Container>
    </section>
  );
};

export default ApiProductFeatures;
